import { useMsal, } from '@azure/msal-react';
import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FileManagerFileMain } from './file-manager-folder';
import { FileVersionToolBar } from './file-manager-toolbar';
import { FileApi } from './../../api/file/file-api';
import _ from 'lodash';

import './previous-versions-styles.css';
import { FileManagerColumns } from './file-manager-colums';
import { arrayAny } from '../../utils/arrayUtils';

export const PreviousVersionModal = ({ show, handleCancel, file, getImage }) => {

    const { instance, inProgress, accounts } = useMsal();
    const [selectedVersions, setSelectedVersions] = useState(null);
    const [enableDelete, setEnableDelete] = useState(false);
    const [rerender, setRerender] = useState(false);

    const readyToShow = show && file && arrayAny(file.previousVersions);

    const api = new FileApi(instance, inProgress, accounts);

    const handleSetSelectedItem = (item) => {

        setRerender(!rerender);

        const existingEntry = selectedVersions ? selectedVersions[item.eTag] : false;
        if (existingEntry) {
            setSelectedVersions(current => {
                delete current[item.eTag];
                setEnableDelete(arrayAny(Object.entries(current)));
                return current;
            });
        }
        else {
            setSelectedVersions(current => {
                current = current ?? {};
                current[item.eTag] = item.versionId;
                setEnableDelete(arrayAny(Object.entries(current)));
                return current;
            });
        }
    }

    const localHandleCancel = () => {
        setSelectedVersions(null);
        handleCancel();
    };

    const handleSelectAll = () => {
        const allVersions = {};

        file.previousVersions.map(pv => allVersions[pv.eTag] = pv.versionId);

        setSelectedVersions(allVersions);
        setEnableDelete(arrayAny(Object.entries(allVersions)));
    };

    const handleUnSelectAll = () => {
        setSelectedVersions(null);
        setEnableDelete(false);
    };

    const handleDeleteSelectedVersions = () =>
        api.queueFileVersionDeletion({ containerName: file.containerName, path: file.path, versions: selectedVersions })
            .then(() => console.log(`Queued deletion of versions. Please allow a short period of time for your request to be processed.`, selectedVersions))
            .catch(error => console.log("Error received from API while queueing deletion of versions", error));

    const versionSelected = (version) => {
        const existingEntry = selectedVersions ? selectedVersions[version.eTag] : null;
        return existingEntry != null;
    };

    const handleMakeCurrentVersion = () => {

        const singleVersionSelected = selectedVersions ? Object.entries(selectedVersions).length === 1 : false
        if (!singleVersionSelected) {
            console.log("You can only make one version the current version.");
            return;
        }

        const versionToPromote = _.first(Object.entries(selectedVersions).map(v => { return { eTag: v[0], version: v[1] } }));
        versionToPromote.path = file.path;

        api.promoteToCurrentVersion(versionToPromote)
            .then(() => console.log("Queueing of Promotion Successful. Refresh in a short while to see update."))
            .catch(error => console.log("An error occurred queueing the promotion of your previous version.", { versionToPromote, error }));

        console.log("Request making current of:", versionToPromote);

    };

    return readyToShow ?
        (
            <Modal
                dialogClassName={"previous-version-dialog"}
                show={show}
                onHide={localHandleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Previous Versions</Modal.Title>
                    <FileVersionToolBar
                        deleteSelectedVersions={handleDeleteSelectedVersions}
                        enableDelete={enableDelete}
                        unSelectAll={handleUnSelectAll}
                        selectAll={handleSelectAll}
                        makeCurrent={handleMakeCurrentVersion}
                        makeCurrentEnabled={selectedVersions ? Object.entries(selectedVersions).length === 1 : false}
                    />
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-striped table-borderless table-sm m-0 text-nowrap">
                        <FileManagerColumns showCheckboxes={true} />
                        <tbody>
                            {arrayAny(file.previousVersions) && file.previousVersions.map((item, i) =>
                                <FileManagerFileMain
                                    key={`file-${i}-${item.name}`}
                                    setSelected={handleSetSelectedItem}
                                    selected={versionSelected(item)}
                                    file={item}
                                    getImage={getImage}
                                    showingModal={true}
                                    showCheckboxes={true}
                                />
                            )}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={localHandleCancel}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        ) :
        (<></>);
};